// node_modules
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FindestButton } from "Components";
import { FindestTextBox } from "Components/Shared/Inputs";
import { Supplier } from "Components/Shared/Supplier";
import { FC, useEffect, useState } from "react";
import Modal from "react-modal";

// styles
import buttonStyles from "styles/buttons.module.scss";
import modalStyles from "styles/modal.module.scss";
import { TOpenGraphMetadata, TSupplierDTO } from "Types";
import styles from "./editSupplierModal.module.scss";

type TEditSupplierModalProps = {
    isOpen: boolean,
    setIsOpen: (isOpenValue: boolean) => void,
    url: string,
    metadata: TOpenGraphMetadata | undefined,
    editingSupplier?: TSupplierDTO,
    onUpdate?: (supplier: TSupplierDTO) => void
}

export const EditSupplierModal: FC<TEditSupplierModalProps> = ({ editingSupplier, isOpen, setIsOpen, metadata, 
        url, onUpdate }: TEditSupplierModalProps) => {

    // State
    const [supplier, setSupplier] = useState<TSupplierDTO>(editingSupplier ? editingSupplier : {
        id: -1,
        url: url,
        companyName: metadata ? metadata.siteName : "",
        pageTitle: metadata?.title,
        faviconUrl: metadata?.favicon,
        pageDescription: metadata?.description,
        pageImageUrl: metadata?.image
    });

    useEffect(() => {
        if(!metadata) return;
        setSupplier({
            id: -1,
            url: url,
            companyName: metadata?.siteName,
            pageTitle: metadata?.title,
            faviconUrl: metadata?.favicon,
            pageDescription: metadata?.description,
            pageImageUrl: metadata?.image
        });
    }, [metadata, url]);

    useEffect(() => {
        if(!editingSupplier) return;
        setSupplier(editingSupplier);
    }, [editingSupplier]);

    // Modal button handlers
    const closeModal = () => {
        setIsOpen(false);
    };

    const onSaveClick = () => {
        if(onUpdate) onUpdate(supplier);
        setIsOpen(false);
    };

    return (
        <Modal 
            className={`${modalStyles.modal} ${modalStyles.center} ${styles.modal}`} 
            overlayClassName={modalStyles.overlay} 
            isOpen={isOpen} 
            onRequestClose={closeModal} 
        >
            <div className={styles.supplierUrl} title="Supplier URL">
                <div className={styles.supplierUrlIcon}>
                    <FontAwesomeIcon icon={faLink} />
                </div>
                <FindestTextBox value={editingSupplier && editingSupplier.url ? editingSupplier.url : url}
                    isReadonly={true} placeholder="Supplier URL" extraClassNameInputElement={styles.supplierUrlInput} />
            </div>

            <Supplier isEditMode={true} supplier={supplier} updateSupplier={setSupplier} />

            <div className={modalStyles.marginTop}>
                <FindestButton extraClassName={[buttonStyles.coloredButton, buttonStyles.purple, buttonStyles.marginRight].join(" ")} title="Save" onClick={onSaveClick} />
                <FindestButton extraClassName={buttonStyles.cancelButton} title="Cancel" onClick={closeModal} />
            </div>

        </Modal>
    );
};